export default "__VITE_ASSET__kbSic32f__"